import templateUrl from './edit-pay-stub.component.html'
import './edit-pay-stub.component.less'

export const EditPayStubComponent = {
    templateUrl,
    bindings: {
        payStub: "<",
        useDailyRsCommission: "<"
    },

    controller: class EditPayStub {
        constructor() {
            'ngInject';
        }

        $onChanges(changesObj) {
        }

        $onInit() {


        }
    }
}
